import React from "react";

import { Button } from "~/ui";

import styles from "./NoRecurring1on1Message.module.css";

export function NoRecurring1on1Message({
	managerName,
	onClickSetUp,
}: {
	managerName: string;
	onClickSetUp: () => void;
}) {
	return (
		<div className={styles.recurring1on1Prompt}>
			<div>
				<p>
					<strong>You do not have a recurring 1-on-1 with {managerName}.</strong>
				</p>
				<p>Recurring 1-on-1s foster productivity and engagement.</p>
				<p>
					<a
						href="https://fellow.app/blog/one-on-ones/the-ultimate-guide-to-recurring-one-on-ones/"
						target="_blank"
						rel="noopener"
					>
						Learn more.
					</a>
				</p>
			</div>
			<Button size="normal" variant="primary" className={styles.setUpBtn} onClick={onClickSetUp}>
				Set up
			</Button>
		</div>
	);
}
